/**
 * Created by mac on 12/23/20
 */

const ShineView = function (unitView) {
    const animation = new cleverapps.Spine(bundles.shine.jsons.shine_animation_json);
    animation.setAnimation(0, "animation", true);
    animation.setAlignment(unitView.width / 2, unitView.height / 2);
    unitView.addChild(animation);
};
